<template>
  <v-btn icon @click="expand">
    <v-icon>{{isExpanded?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
  </v-btn>
</template>

<style lang="scss">
</style>

<script>
export default {
  name: "v-btn-expand",
  props: {
    isExpanded: Boolean,
    expandedID: String,
    value: Array
  },
  data: () => ({}),
  computed: {},
  methods: {
    expand() {
      const index = this.value.indexOf(this.expandedID);
      if (index > -1) {
        this.value.splice(index, 1);
      } else {
        this.value.push(this.expandedID);
      }
    }
  },
  mounted() {}
};
</script>

